<template>
  <div class="">
    <PreLoader v-if="isLoading" />

    <form
      autocomplete="off"
      method="post"
      @submit.prevent="addOrUpdateCustodyExpense()"
    >
      <div class="my-card">
        <div class="row">
          <CustomSelectBox
            :className="'col-md-6'"
            :id="'employeeToken'"
            :value="custodyExpense.employeeToken"
            :options="employeeTokenOptions"
            v-on:changeValue="custodyExpense.employeeToken = $event"
            :title="$t('selectEmployee')"
            :imgName="'employees.svg'"
          />
          <CustomInput
            :className="'col-md-6'"
            :id="'custodyExpenseNameAr'"
            :value="custodyExpense.custodyExpenseNameAr"
            v-on:changeValue="custodyExpense.custodyExpenseNameAr = $event"
            :title="$t('CustodyExpenses.nameAr')"
            :imgName="'CustodyExpenses.svg'"
          />
          <CustomInput
            :className="'col-md-6'"
            :id="'custodyExpenseNameEn'"
            :value="custodyExpense.custodyExpenseNameEn"
            v-on:changeValue="custodyExpense.custodyExpenseNameEn = $event"
            :title="$t('CustodyExpenses.nameEn')"
            :imgName="'CustodyExpenses.svg'"
          />
          <CustomInput
            :className="'col-md-6'"
            :id="'custodyExpenseNameUnd'"
            :value="custodyExpense.custodyExpenseNameUnd"
            v-on:changeValue="custodyExpense.custodyExpenseNameUnd = $event"
            :title="$t('CustodyExpenses.nameUnd')"
            :imgName="'CustodyExpenses.svg'"
          />

          <TextArea
            :className="'col-md-6'"
            :id="'custodyExpenseDescriptionAr'"
            :value="custodyExpense.custodyExpenseDescriptionAr"
            v-on:changeValue="
              custodyExpense.custodyExpenseDescriptionAr = $event
            "
            :title="$t('CustodyExpenses.descriptionAr')"
            :imgName="'description.svg'"
          />
          <TextArea
            :className="'col-md-6'"
            :id="'custodyExpenseDescriptionEn'"
            :value="custodyExpense.custodyExpenseDescriptionEn"
            v-on:changeValue="
              custodyExpense.custodyExpenseDescriptionEn = $event
            "
            :title="$t('CustodyExpenses.descriptionEn')"
            :imgName="'description.svg'"
          />
          <TextArea
            :className="'col-md-6'"
            :id="'custodyExpenseDescriptionUnd'"
            :value="custodyExpense.custodyExpenseDescriptionUnd"
            v-on:changeValue="
              custodyExpense.custodyExpenseDescriptionUnd = $event
            "
            :title="$t('CustodyExpenses.descriptionUnd')"
            :imgName="'description.svg'"
          />
          <TextArea
            :className="'col-md-6'"
            :id="'custodyExpenseNotes'"
            :value="custodyExpense.custodyExpenseNotes"
            v-on:changeValue="custodyExpense.custodyExpenseNotes = $event"
            :title="$t('notes')"
            :imgName="'notes.svg'"
          />
        </div>
      </div>

      <div class="form-footer">
        <button name="submit" type="submit" class="btn btn-submit">
          {{ submitName }}
        </button>
        <router-link :to="{ name: 'CustodyExpenses' }" class="btn btn-cancel">
          {{ $t("cancel") }}
        </router-link>
      </div>
    </form>
  </div>
</template>

<script>
import PreLoader from "@/components/general/PreLoader.vue";
import CustomSelectBox from "@/components/general/CustomSelectBox.vue";
import CustomInput from "@/components/general/CustomInput.vue";
import TextArea from "@/components/general/TextArea.vue";
import { STATUS } from "@/utils/constants";
import axios from "axios";
import createToastMixin from "@/utils/create-toast-mixin";

export default {
  mixins: [createToastMixin],
  components: {
    PreLoader,
    CustomSelectBox,
    CustomInput,
    TextArea,
  },
  data() {
    return {
      isLoading: false,
      exceptionMsg: null,
      exceptionImg: null,
      language: localStorage.getItem("userLanguage") || "ar",
      userAuthorizeToken:
        this.$store.getters.userData.userPersonalData.userAuthorizeToken ||
        null,
      employeeTokenOptions: [],
    };
  },
  props: ["custodyExpense", "submitName"],
  methods: {
    async getDialogOfEmployees() {
      this.isLoading = true;
      this.employeeTokenOptions = [];
      this.employeeTokenOptions.push({
        value: "",
        text: this.$t("selectEmployee"),
      });
      try {
        const response = await axios.get(
          `/Employees/GetDialogOfEmployees?language=${this.language}&userAuthorizeToken=${this.userAuthorizeToken}`
        );
        const itemsData = response.data.itemsData;
        if (response.data.status == STATUS.SUCCESS) {
          for (let item in itemsData) {
            this.employeeTokenOptions.push({
              value: itemsData[item]["itemToken"],
              text: itemsData[item]["itemName"],
            });
          }
        } else if (response.data.status == STATUS.INVALID_TOKEN) {
          this.$store.dispatch("logoutUser");
          this.$router.push("/").catch(() => {});
        }
        this.isLoading = false;
      } catch (error) {
        this.showMsg(this.$t("errorCatch"));
      }
      this.isLoading = false;
    },
    addOrUpdateCustodyExpense() {
      this.$emit("addOrUpdateCustodyExpense");
    },
  },
  watch: {},
  created() {
    this.getDialogOfEmployees();
  },
};
</script>
